import { render, staticRenderFns } from "./AssignmentSubmission.vue?vue&type=template&id=26289996"
import script from "./AssignmentSubmission.vue?vue&type=script&lang=js"
export * from "./AssignmentSubmission.vue?vue&type=script&lang=js"
import style0 from "./AssignmentSubmission.vue?vue&type=style&index=0&id=26289996&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports